import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Modal, Box, Typography, Stack, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { closeDataModal } from 'handimap-react-lib/store/actions/modalActions';
import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { config } from 'handimap-react-lib/config.js';

export const DataModal = () => {
  /**
   * Accessibility infos: https://www.w3.org/WAI/ARIA/apg/patterns/dialogmodal/
   *                      https://www.accede-web.com/notices/interface-riche/fenetres-modales/
   */
  const { openData } = useSelector(state => state.modalZone); 
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();
  const {t} = useTranslation();

  const handleCloseModal = () => {
    dispatch(closeDataModal());
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '80%' : '50%',
    bgcolor: 'background.paper',
    borderRadius: '1em',
    boxShadow: 24,
    paddingX: 4,
    paddingBottom: 4,
    outline: 'none',
    maxHeight:'85%',
    minWidth: isMobile ? '60%' : 600, 
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-track': {
      width: '2px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '0.5em',
      backgroundColor: 'gray'
    }
  };

  return (
    <Modal
      open={openData}
      onClose={() => handleCloseModal()}
      aria-labelledby="modal-zone-title"
      aria-describedby="modal-zone-description"
      role="dialog" 
      aria-modal="true"
    >
      <Box sx={style}>
        <Box sx={{ 
          display: 'flex', 
          width: '100%',
          top: 0,
          justifyContent: 'flex-end',
          backgroundColor: 'inherit',
          position: 'sticky', 
          zIndex: 100
        }}>
          <Button aria-label={t('modal-data.close-modal')} variant='text' sx={{backgroundColor: 'white', marginTop:'0.5em'}} onClick={() => handleCloseModal()}>
            <FontAwesomeSvgIcon sx={{fontSize: '2em',}} icon={faTimes} />
          </Button>
        </Box>
        <Stack sx={{display: 'flex', maxHeigth:'80%'}} direction='column' spacing={2}>
          <Box sx={{alignSelf: 'center'}}>
            <Typography id="modal-zone-title" variant="h4" component="h1">
              {t('modal-data.title')}
            </Typography>
          </Box>
          <Box sx={{justifyContent: 'center'}}>
            <Typography id="modal-zone-description" sx={{whiteSpace: 'pre-line'}}>
              {t('modal-data.intro')}
            </Typography>
            <Stack direction= {isMobile ? 'column': 'row'} spacing={2} sx={{marginY: '1em'}} >

              <Box 
                component="img"
                sx={{
                  backgroundColor: 'white',
                  height: isMobile ? null :'12em',
                  width: isMobile ? '80%': null
                }} 
                src={config.url.PUBLIC_URL + '/nouveau-logo-TH.png'}
                alt=""
                aria-label={t('selectedFeature.aria-th-logo')}
              />
              <Box style={{whiteSpace: 'pre-line', margin: 'auto'}}>
                <Typography component="h2" sx={{fontFamily: 'Luciole-bold'}}>
                  {t('modal-data.th-title')}
                </Typography>
                <Typography component="p" sx={{paddingY: '0.5em'}}>
                  {t('modal-data.th-desc')}
                </Typography>
              </Box>
            </Stack>
            <Stack direction={isMobile ? 'column': 'row'} spacing={1} sx={{marginY: '1em'}} >

              <Box 
                component="img"
                sx={{
                  backgroundColor: 'white',
                  height: isMobile ? null :'6em',
                  width: isMobile ? '80%': null
                }} 
                src={config.url.PUBLIC_URL + '/Logo-DestinationAccessible.jpg'}
                alt=""
                aria-label={t('selectedFeature.aria-dest-acc-logo')}
              />
              <Typography component="h2" style={{fontFamily: 'Luciole-bold', margin: 'auto'}}>
                {t('modal-data.dest-acc-title')}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};